<template>
  <div class="myTracks">
    <topTitle title="浏览足迹">
      <button @click="editFun">{{edit?'完成':'编辑'}}</button>
    </topTitle>
    <div class="tracks">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        offset="0"
        :immediate-check='false'
        @load="onLoad()"
      >
        <div v-for="(item,i) in typeCount" :key="i" v-show="item.history.length!=0">
          <div class="time">{{item.time}}</div>
          <div class="goodsList">
            <div class="item" v-for="(obj,index) in item.history" :key="index">
              <h2 @click="toShop(obj)">
                {{obj.shop_name}}
                <img src="../../assets/localImage/path.png" alt />
              </h2>
              <div>
                <van-checkbox v-model="obj.show" v-if="edit"></van-checkbox>
                <div class="img" @click="toDetail(obj)">
                  <img :src="obj.goods_img ? obj.goods_img : $store.state.defaultgwc" alt />
                </div>
                <div class="name" @click="toDetail(obj)">
                  <p>{{obj.goods_name}}</p>
                  <span>￥{{obj.goods_price}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="footOperation" v-if="edit">
        <button @click="delRecord()">删除记录</button>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
import { Toast } from 'vant';
export default {
  name: "myTracks",
  data() {
    return {
      loading: false,
      finished: false,

      checked: true,
      edit:false,
      page_no:1,
      page_size:10,

      num:0,
      typeCount:[],
      map:{}
    };
  },
  components: {
    topTitle
  },
  created(){
    this.tracks()
  },
  methods: {
    onLoad(){
        this.page_no = this.page_no + 1;
        this.tracks();
    },
    toShop(obj){
      this.$router.push({path:'shopIndex',query:{shop_id:obj.shop_id}});
    },
    toDetail(obj){
      this.$router.push({path:'goodsDetail',query:{goods_id:obj.goods_id}});
    },

    tracks(){
      this.getRequest( `members/history/list`,{page_no:this.page_no,page_size:this.page_size}).then(res => {
        if(res.data.code == 1){
          this.typeCount = [];
        }else{
          // this.tracksList =  res.data.data.data;
          
          // num=0,typeCount=[],map={},
          let type='time'
          res.data.data.data.forEach(obj=>{
            obj.time =  this.timeConvert(obj.time,2)
            if(obj.history.length!=0){
              obj.history[0].show = false;
            }
            var value = this.map[String(obj[type])];
            if(value !== void 0){
                this.typeCount[value].history = this.typeCount[value].history.concat(obj.history)
            }else{
                this.map[obj[type]] = this.num;
                this.typeCount.push(obj);
                this.num++;
            }
          })
          this.loading = false;
          // 数据全部加载完成
          if (res.data.data.data.length < 10) {
            this.finished = true;
          }
          console.log(this.typeCount)
          // this.tracksList = this.typeCount;
        }
      })
    },
    editFun() {
      this.edit = !this.edit
    },
    delRecord(){
      console.log(this.typeCount)
      let arr = [];
      this.typeCount.forEach(obj=>{
        obj.history.forEach(element=>{
          if(element.show){
            arr.push(element.id)
          }
        })
      })
      if(arr.length>0){
         let memberStr = arr.join(',')
        this.deleteRequest(`members/history/${memberStr}`).then(res => {
            this.typeCount.forEach(obj=>{
              obj.history = obj.history.filter(element=>{return !element.show})
            })
            Toast.success('删除记录');
        })
      }
      
    }
  }
};
</script>


<style scoped lang='less'>
.myTracks {
  .tracks {
    .time {
      height: 89px;
      line-height: 89px;
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      padding: 0 18px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .goodsList {
    padding: 0 18px;
    .item {
      width: 714px;
      height: 302px;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      padding: 31px 26px;
      display: flex;
      flex-direction: column;
      margin: auto;
      margin-bottom: 20px;
      h2 {
        font-size: 26px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        img {
          width: 12px;
          height: 20px;
          display: inline-block;
          margin-left: 10px;
        }
      }
      > div {
        margin-top: 29px;
        display: flex;
        justify-content: space-between;

        .img {
          width: 180px;
          height: 180px;
          margin-right: 30px;
          img{
            max-width: 100%;
            max-height: 180px;
          }
        }
        .name {
          flex: 1;
          padding-bottom: 24px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p {
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 37px;
          }
          span {
            font-size: 22px;
            font-family: AlibabaPuHuiTiM;
            color: rgba(255, 25, 25, 1);
          }
        }
      }
    }
    .item:last-child{
        margin-bottom: 0px;
    }
  }
}
</style>


